import access from './icons/access.svg';
import apps from './icons/apps.svg';
import book from './icons/book.svg';
import calendar from './icons/calendar.svg';
import close from './icons/close.svg';
import culture from './icons/culture.svg';
import food from './icons/food.svg';
import goodPractice from './icons/goodPractice.svg';
import home from './icons/home.svg';
import hotelEvent from './icons/hotelEventIcon.svg';
import info from './icons/info.svg';
import kids from './icons/kid.svg';
import mapPin from './icons/map-pin.svg';
import phoneBook from './icons/phone-book-icon.svg';
import qrCode from './icons/QR-code.svg';
import regulations from './icons/regulations.svg';
import rentals from './icons/rent.svg';
import opinion from './icons/review.svg';
import socialMedia from './icons/socialDark.svg';
import specialOffers from './icons/special-offer.svg';
import trip from './icons/trip.svg';
import user from './icons/user.svg';
import virtualTour from './icons/virtual-tour-black.svg';
import wifi from './icons/wifi.svg';

const appIcon = {
  access,
  close,
  phoneBook,
  apps,
  book,
  home,
  hotelEvent,
  user,
  mapPin,
};

const homeMenuIcon = {
  calendar,
  goodPractice,
  hotelEvent,
  qrCode,
  info,
  specialOffers,
  opinion,
  rentals,
  virtualTour,
  socialMedia,
  wifi,
  regulations,
};

const attractionsIcon = { food, kids, trip, culture };

export { appIcon, attractionsIcon, homeMenuIcon };
